import React, { useState, useEffect } from "react";
import AdminHead from "./AdminHead";
import { db, storage } from "../Components/Firebase";
import {
    collection,
    addDoc,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import "../Styles/Admin/Ads.css";

function Ads() {
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        name: "",
        info: "",
        image: null, // File or URL
    });

    const [preview, setPreview] = useState(null); // preview image
    const [editId, setEditId] = useState(null);

    // Load ads
    const loadAds = async () => {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, "Ads"));
        const list = querySnapshot.docs.map((d) => ({
            id: d.id,
            ...d.data(),
        }));
        setAds(list);
        setLoading(false);
    };

    useEffect(() => {
        loadAds();
    }, []);

    // When selecting a new image → show preview
    const handleImageChange = (file) => {
        setFormData({ ...formData, image: file });

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    // Upload image
    const uploadImage = async (file) => {
        if (!file) return null;
        const storageRef = ref(storage, `Ads/${Date.now()}_${file.name}`);
        await uploadBytes(storageRef, file);
        return await getDownloadURL(storageRef);
    };

    // Create or Update
    const handleSubmit = async (e) => {
        e.preventDefault();

        let imageUrl = formData.image;

        // If new file → upload
        if (formData.image && typeof formData.image !== "string") {
            imageUrl = await uploadImage(formData.image);
        }

        const dataToSave = {
            name: formData.name,
            info: formData.info,
            imageUrl: imageUrl || "",
        };

        if (editId) {
            await updateDoc(doc(db, "Ads", editId), dataToSave);
        } else {
            await addDoc(collection(db, "Ads"), dataToSave);
        }

        // Reset form
        setFormData({ name: "", info: "", image: null });
        setPreview(null);
        setEditId(null);
        loadAds();
    };

    // Delete ad
    const handleDelete = async (id) => {
        await deleteDoc(doc(db, "Ads", id));
        loadAds();
    };

    // Delete only image during edit
    const handleDeleteImage = async () => {
        if (!formData.image || typeof formData.image !== "string") return;

        try {
            const url = formData.image;
            const storagePath = url.split("/o/")[1].split("?")[0];
            const decodedPath = decodeURIComponent(storagePath);

            const imageRef = ref(storage, decodedPath);
            await deleteObject(imageRef);

            // Remove from form
            setFormData({ ...formData, image: null });
            setPreview(null);

        } catch (error) {
            console.error("Image delete error:", error);
        }
    };

    // Edit ad
    const handleEdit = (ad) => {
        setEditId(ad.id);
        setFormData({
            name: ad.name,
            info: ad.info,
            image: ad.imageUrl,
        });
        setPreview(ad.imageUrl);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <React.Fragment>
            <AdminHead />

            <div className="ads-container">

                <form className="ad-form" onSubmit={handleSubmit}>
                    <h2>{editId ? "עריכת מודעה" : "הוספת מודעה חדשה"}</h2>

                    <input
                        type="text"
                        placeholder="שם המודעה"
                        value={formData.name}
                        onChange={(e) =>
                            setFormData({ ...formData, name: e.target.value })
                        }
                        required
                    />

                    <textarea
                        placeholder="מידע על המודעה"
                        value={formData.info}
                        onChange={(e) =>
                            setFormData({ ...formData, info: e.target.value })
                        }
                        required
                    />

                    <label className="file-input">
                        העלאת תמונה
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageChange(e.target.files[0])}
                        />
                    </label>

                    {/* Preview Image */}
                    {preview && (
                        <div className="preview-container">
                            <img className="preview-img" src={preview} alt="Preview" />

                            {/* Delete image when editing */}
                            {editId && typeof formData.image === "string" && (
                                <button
                                    type="button"
                                    className="delete-image-btn"
                                    onClick={handleDeleteImage}
                                >
                                    מחק תמונה
                                </button>
                            )}
                        </div>
                    )}

                    <button className="submit-btn" type="submit">
                        {editId ? "עדכן" : "צור מודעה"}
                    </button>
                </form>

                {/* Ads Grid */}
                <h2 className="title">מודעות</h2>

                {loading ? (
                    <p>טוען...</p>
                ) : (
                    <div className="ads-grid">
                        {ads.map((ad) => (
                            <div className="ad-card" key={ad.id}>
                                <img src={ad.imageUrl} alt="Ad" />
                                <h3>{ad.name}</h3>
                                <p>{ad.info}</p>

                                <div className="card-buttons">
                                    <button onClick={() => handleEdit(ad)}>
                                        ערוך
                                    </button>
                                    <button
                                        className="delete-btn"
                                        onClick={() => handleDelete(ad.id)}
                                    >
                                        מחק
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default Ads;
